import React from "react";
import { motion } from "framer-motion";
import styles from "./BlogList.module.css";
import { blogPosts } from "../data/blog";
import { useSound } from "../context/SoundContext";

const listVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1, transition: { staggerChildren: 0.1 } },
  out: { opacity: 0 },
};

const itemVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
};

const BlogList = ({ viewPost }) => {
  const { playHover, playClick } = useSound();

  return (
    <motion.div initial="initial" animate="in" exit="out">
      {blogPosts.map((post) => (
        // Add the onClick handler here
        <motion.div
          key={post.id}
          className={styles.blogRow}
          onMouseEnter={playHover}
          onClick={() => {
            playClick();
            viewPost(post.id);
          }}
        >
          <span className={styles.blogTitle}>{post.title}</span>
          <span className={styles.blogDate}>{post.date}</span>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default BlogList;
